import { api } from "../api";

/**
 * updateGroupStatusById - Function that updates on database an existing group status by id   
 * /groups/{customerId}/{departmentId}/{id}/{status}  
 * method PUT 
 * @async-function
 */
const updateGroupStatusById = async (token: string, id: number, customerId: number, departmentId: number, status: string) => {
    const response = await api.put(
        `/groups/${customerId}/${departmentId}/${id}/${status}`, {}, {
             headers: { 'Authorization': `Bearer ${token}` }
        });

    return response;
};
export default updateGroupStatusById;
